module.exports = __webpack_public_path__ + "img/icon-mother.6baaa9f9.png";